import React, { useRef, useState } from 'react';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import validator from 'validator';
import { sendRequest } from '../../services/global/global.service';
import { urlConfig } from '../../config/urlConfig';
import { CircularProgress, makeStyles, Typography } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  wrapper: {
    margin: '24px 16px 24px 0',
    position: 'relative',
  },
  submitBox: {
    display: 'flex',
    alignItems: 'center',
  },
  buttonProgress: {
    color: '#000',
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12,
  },
}));

export default function FormDialog() {
  const classes = useStyles();

  const [open, setOpen] = useState(false);
  const emailRef = useRef(null);
  const [email, setEmail] = useState('');
  const [emailError, setEmailError] = useState(false);
  const [emailIsValid, setEmailIsValid] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [isReset, setIsReset] = useState(false);

  const ForgotPassword = () => (
    <>
      <DialogTitle id='form-dialog-title'>Forgot your password?</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Enter your e-mail address below, and we'll send you an e-mail allowing
          you to reset it.
        </DialogContentText>
        <TextField
          autoFocus
          margin='dense'
          id='email'
          name='email'
          label='Email Address'
          type='email'
          value={email}
          fullWidth
          inputRef={emailRef}
          error={emailError}
          helperText={
            <Typography color='error' variant='caption'>
              {emailIsValid}
            </Typography>
          }
          onChange={(e) => {
            setEmail(e.target.value);
          }}
        />
      </DialogContent>
      <DialogActions>
        <div className={classes.submitBox}>
          <Button disabled={isLoading} onClick={() => setOpen(false)}>
            Cancel
          </Button>

          <div className={classes.wrapper}>
            {isLoading && (
              <CircularProgress size={24} className={classes.buttonProgress} />
            )}
            <Button
              disabled={isLoading}
              onClick={submitHandler}
              color='primary'
            >
              Send
            </Button>
          </div>
        </div>
      </DialogActions>
    </>
  );

  const SuccessMsg = () => (
    <>
      <DialogTitle id='form-dialog-title'>Email has been sent</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Please check your email inbox for a password recovery link. Don't
          forget to check your spam folder.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          disabled={isLoading}
          onClick={() => {
            setOpen(false);
          }}
          color='primary'
        >
          close
        </Button>
      </DialogActions>
    </>
  );

  const submitHandler = (e) => {
    e.preventDefault();
    setEmailError(false);
    setIsReset(false);
    setEmailIsValid('');

    if (validator.isEmpty(email)) {
      setEmailError(true);
      emailRef.current.focus();
    }
    if (!validator.isEmpty(email) && !validator.isEmail(email)) {
      emailRef.current.focus();
      setEmailIsValid(' Enter valid Email address! ');
    }

    if (!validator.isEmpty(email) && validator.isEmail(email)) {
      setIsLoading(true);
      sendRequest(urlConfig.reset_password_url, null, 'post', {
        email,
      })
        .then((res) => {
          setIsReset(true);
          setIsLoading(false);
          setEmail('');
          setEmailError(false);
          setEmailIsValid('');
        })
        .catch((e) => {
          setIsReset(false);
          setIsLoading(false);
          setEmailIsValid(e.toString());
          e.response &&
            e.response.data &&
            e.response.data.email &&
            setEmailIsValid(e.response.data.email.toString());
        });
    }
  };

  return (
    <div>
      <Button
        disabled={isLoading}
        variant='outlined'
        size='small'
        p={0}
        onClick={() => {
          setEmail('');
          setEmailError(false);
          setEmailIsValid('');
          setOpen(true);
        }}
        className={classes.link}
      >
        Forgot password?
      </Button>
      <Dialog
        open={open}
        onClose={() => {
          setOpen(false);
        }}
        aria-labelledby='forgot-password'
      >
        {!isReset ? <ForgotPassword /> : <SuccessMsg />}
      </Dialog>
    </div>
  );
}
